export function isBrowser() {
  return true;
}

function getHostname() {
  return global.window.location.hostname;
}

export function getOrigin() {
  return global.window.location.origin;
}

/**
 * Returns the environment identifier (hostname)
 *
 * @returns {string} The identifier for the running environment.
 */
export function getEnvironment() {
  return getHostname() || 'local';
}

/**
 * `.net`, `local`, and `localhost` are the only environments we consider internal.
 *
 * @returns {boolean} Whether or no the current environment would be consided internal.
 */
export function isInternal() {
  return getEnvironment().includes('.net') === true || getEnvironment().startsWith('local');
}

/**
 * Only `albert.io` and its subdomains serve customers. Any other host, including one we have not
 * named, is not production.
 *
 * @param {string} hostname The host to check. Defaults to the running page's host.
 * @returns {boolean} Whether the host belongs to the production environment.
 */
export function isProductionHost(hostname = getHostname()) {
  return hostname === 'albert.io' || hostname.endsWith('.albert.io');
}

/**
 * Retrieve a variable from the running environment.
 * - For the browser this looks in `global.__CONSTANTS__`
 *
 * @param {string} name The name of the environment variable to retrieve.
 * @returns {*} The value found in the running environment.
 */
export function getEnvironmentVariable(name) {
  return global.__CONSTANTS__[name];
}

/**
 * Returns the Mandark host
 *
 * @returns {string} The full host to be used in the running environment.
 */
export function getHost() {
  const mandarkOrigin = process.env.MANDARK_EXTERNAL_ORIGIN;

  // if relative, prepend the origin
  if (mandarkOrigin && mandarkOrigin.startsWith('/')) {
    return `${getOrigin()}${mandarkOrigin}`;
  }

  return mandarkOrigin;
}

/**
 * A simple utility for constructing a URL to Mandrk using the running environment's host.
 *
 * @param {string} path The relative path of the endpoint.
 * @returns {string} The full Mandark URL including protocol, host, port and path.
 */
export function getMandarkURL(path = '') {
  return `${getHost()}${path}`;
}
